$(function () {
    /**
     * Cart sidebar
     */
    $("body").on('click', '.btn-cart-sidebar', function (e) {
        e.preventDefault();
        showMiniCart();
    });

    $("body").on('click', '*[data-action="close-minicart"]', function (e) {
        e.preventDefault();
        closeMiniCart();
    });

    function showMiniCart(){
        $('body').toggleClass('show-cart-sidebar');
    }

    function closeMiniCart(){
        $('body').removeClass('show-cart-sidebar');
    }

    /**
     * Search popup
     */
    $("body").on('click', '.btn-search-popup', function (e) {
        e.preventDefault();
        showSearch();
    });

    $("body").on('click', '*[data-action="close-search"]', function (e) {
        e.preventDefault();
        closeSearch();
    });

    function showSearch(){
        $('body').toggleClass('show-search');
    }

    function closeSearch(){
        $('body').removeClass('show-search');
    }
    /* related posts slider */

  $(function () {
    $('.related-articles .owl-carousel').owlCarousel({
      loop: 0,
      autoplay: 0,
      margin: 30,
      nav: 1,
      dots: 0,
      responsive: {
        0: {
          items: 1,
        },
        481: {
            items: 2,
        },
        768: {
            items: 2,
        },
        992: {
            items: 3,
        },
        1200: {
            items: 3,
        },
        1441: {
            items: 3,
        },
        1681: {
            items: 3,
        },
        1921: {
            items: 3,
        }
      }
    });
  });

  $(function () {
    $('.partner-brand .owl-carousel').owlCarousel({
      loop: 0,
      autoplay: 0,
      margin: 30,
      nav: 1,
      dots: 0,
      responsive: {
        0: {
          items: 1,
        },
        481: {
            items: 2,
        },
        768: {
            items: 2,
        },
        992: {
            items: 3,
        },
        1200: {
            items: 3,
        },
        1441: {
            items: 3,
        },
        1681: {
            items: 3,
        },
        1921: {
            items: 3,
        }
      }
    });
  });

  $(window).scroll(function() {
    var header_height = $(".header").height()+50;
    if ($(this).scrollTop() >= header_height) {
      $('.header.header-fixed').addClass('stickytop');
    }
    else {
      $('.header.header-fixed').removeClass('stickytop');
    }
  });
  
/* Mobile header */
function isEmpty( el ){
    return !$.trim(el.html())
}

function mobile_header(){
    if ($(window).width() <= 1024) {
        if (isEmpty($('#cart-mobile'))) { $('.header-desktop .header-cart.minicart-header').clone().appendTo('#cart-mobile'); }
        if (isEmpty($('#search-mobile'))) { $('.header-desktop .search-header #search-desktop').clone().appendTo('#search-mobile'); }
        if (isEmpty($('#menu-mobile'))) { $('.header-desktop .header-megamenu .megamenu-horizontal .horizontal-content').clone().appendTo('#menu-mobile'); }
    }
}
mobile_header();
var windowWidth = $(window).width();
$(window).on('resize', function(){
    // If the window width has changed...
    if(windowWidth != $(window).width()) {
        mobile_header();
    }
});

$("body").on('click', '#mobile-nav,.nav-mobile-overlay,.close-mobile', function () {
    $('body').toggleClass('show-nav-mobile');
});

$("body").on('click', '#menu-mobile .menu-items >.item .btn-drop-mobile', function () {
    $(this).closest('.item').toggleClass('show-dropdown-menu');
});

if ($(window).width() <= 767) {
    
    $('.tab-container .list-tabs .tab-item.active .tab-title').clone().appendTo('.tabs-drop-mobile');
    $('.tabs-drop-mobile').on('click', function(){
        $(this).closest('.tab-container').toggleClass('active');
    });
    $('.tab-container .list-tabs .tab-item').on('click', function(){
        var tit = $(this).find('.tab-title').clone();
        $('.tabs-drop-mobile').html(tit);
        $(this).closest('.tab-container').removeClass('active');
    });
}

});



(function() {
	'use strict';

	/*
		Reposition the HotSpots during init and resize windows
	*/
	function _positionHotspots(options) {
		var imageWidth = $(options.mainselector + ' ' + options.imageselector).prop('naturalWidth'); 
		var imageHeight = $(options.mainselector + ' ' + options.imageselector).prop('naturalHeight');

		var bannerWidth = $(options.mainselector).width();
		var bannerHeight = $(options.mainselector).height();
		$(options.selector).each(function() {
			var xPos = $(this).attr('x');
			var yPos = $(this).attr('y');
			xPos = xPos / imageWidth * bannerWidth;
			yPos = yPos / imageHeight * bannerHeight;

			$(this).css({
				'top': yPos,
				'left': xPos,
				'display': 'block',
			});
			$(this).children(options.tooltipselector).css({
				'margin-left': - ($(this).children(options.tooltipselector).width() / 2)
			});
		});
	}

	// Bind the events (hover or click) for the tooltip
	function _bindHotspots(e, options) {
			if ($(e).children(options.tooltipselector).is(':visible')) {
				$(e).children(options.tooltipselector).css('display', 'none');
			} else {
				$(options.selector + ' '  + options.tooltipselector).css('display', 'none');
				$(e).children(options.tooltipselector).css('display', 'block');
				if ($(window).width() - ($(e).children(options.tooltipselector).offset().left + $(e).children(options.tooltipselector).outerWidth()) < 0) {
					$(e).children(options.tooltipselector).css({
						'right': '0',
						'left': 'auto',
					});
				}
			}
	}
	
	$.fn.hotSpot = function( options ) {
 
    // Extend our default options with those provided.
    // Note that the first argument to extend is an empty
    // object – this is to keep from overriding our "defaults" object.
    var _options = $.extend( {}, $.fn.hotSpot.defaults, options );
 
		// Position each hotspot
		this.each(function() {
				_positionHotspots.call($(this), _options);
		});

		// Bind the windows resize event to recalculate the hotspot position
		$(window).resize(function() {
				this.each(function() {
						_positionHotspots.call($(this), _options);
				});
		}.bind(this));

		// Bind the hover/click for selector to show the tooltip
		switch (_options.bindselector) {
			case 'click':
				$(_options.selector).bind ('click', function(e){_bindHotspots(e.currentTarget, _options)});
				break;
			case 'hover':
				$(_options.selector).hover (function(e){_bindHotspots(e.currentTarget, _options)});
				break;
			default:
				break;
		}
		
		return this;
	};
	
	// Plugin defaults
	$.fn.hotSpot.defaults = {
		mainselector: '#hotspotImg',
		selector: '.hot-spot',
		imageselector: '.img-responsive',
		tooltipselector: '.tooltip',
		bindselector: 'hover'
	};
}(jQuery));

